import {Navigate} from 'react-router-dom';

type Props = {
    redirectPath: string;
};

export const NotAuthorized = ({redirectPath}: Props) => {
    return <Navigate to={redirectPath} />;
};
